export default "__VITE_ASSET__dc49f2ef__"